import $ from 'jquery';
window.jQuery = $;

$('.accordion h2, .accordion h3').on('click', function () {
  $(this).toggleClass('active');
  $(this).closest('li').find('> .accordion-content').slideToggle(300);
});

$('.accordion-content.text svg').on('click', function () {
  $(this).closest('li').find('> .accordion-content').slideToggle(300);
  $(this).closest('li').find('h2').toggleClass('active');
  $(this).closest('li').find('h3').toggleClass('active');
});

$('button.more').on('click', function () {
  let text = $(this).text();

  $(this).text(text === 'Read More' ? 'Read Less' : 'Read More');

  $('.read-more').slideToggle(300);
});
